<template>
  <div class="section-row" v-if="visible">
    <span class="section-row-header">{{resources.pickADeliveryMethodLabel}}</span>

    <div class="horizontal-tile-list" v-if="!loadingState">
        <delivery-method-tile v-for="method in methods" :key="method.id" :method="method" />
    </div>
    <loader-animation :isHorizontal="true" :number="methods.length" v-if="loadingState"/>
  </div>
</template>
<script src="./delivery-method-tile-list.js"/>